"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_APPT_INFO = exports.FETCH = void 0;
const FETCH = exports.FETCH = '@actions/FETCH';
const SET_APPT_INFO = exports.SET_APPT_INFO = '@actions/SET_APPT_INFO';